export class GamesService {
    constructor(httpService) {
        this.httpService = httpService;
    }
    async checkIfCodeIsInUse(gameCode) {
        const response = await this.httpService.post('game/code', { gameCode });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los estados de las salas.');
        }
        return response.json();
    }
}
